import Shipping from "../../../../form/shipping/shipping";
import React, {Fragment} from "react";
import classNames from 'classnames';

export default (propsTop) => {
    const {props, state, parent, control} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return (hidden || []).indexOf("shipping") === -1 && <div className="section">
        <div className="section-title">Szállítás</div>
        <Shipping
            availableProviders={props.availableShippingProviders}
            name="shipping"
            client={props}
            layout={(fields) => <Fragment>
                {control && control.hidden && control.hidden.includes('serviceprovider') ? null : fields.serviceprovider_type}
                <div className="col-md-12">
                    <div className="row">
                        <div className={classNames({"col-md-9": fields.request, "col-md-12": !fields.request})}>
                            <div className="row">
                                {fields.postcode}
                                {fields.city}
                                {fields.address}
                                {control && control.hidden && control.hidden.includes('origin') ? null : fields.origin}
                                {fields.destination}
                            </div>
                        </div>
                        {fields.request && <div className="col-md-3">
                            <div className="row">
                                {fields.request}
                            </div>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="row">
                                {fields.contact}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                {fields.email}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="row">
                                {fields.telnum}
                            </div>
                        </div>
                        <div className="col-md-1">
                            <div className="row">
                                {fields.autoInfo}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6 currency">
                            {fields.shipping_fee}
                        </div>
                        <div className="col-md-6">
                            {fields.vat}
                        </div>
                    </div>
                </div>
            </Fragment>}
            {...props.getProps("shipping")}
            value={props.getValue("shipping")}
            saveChanges={props.setFieldValue}
        />
    </div>;
}